<template>
	<div class='knd-loader' ref="knd-loader">
		Laden
	</div>

	<Story />
</template>

<script>

import Story from './story/story';
import './scss/index.scss'

export default {
	name: 'App',
	mounted: function() {
		this.$refs["knd-loader"].style.display = "none";

		// console.log(this.$store.state.content)
	},
	components: {
		Story
	}
}
</script>
